import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import "../../App.css";
import "./Forms.css";

import configIcon from "../../assets/icons/configuracoes.png";
import ConfiguracoesService from "../../services/ConfiguracoesService";

export default function ConfiguracoesForm({
  itemSelecionado,
  modo,
  onSubmit,
  onClose,
}) {
  const [form, setForm] = useState({
    idParametro: null,
    chave: "",
    descricao: "",
    unidade: "",
    valor: "",
    ativo: "1",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { setRetorno } = useGerenciamento();
  const [submitState, setSubmitState] = useState("IDLE");

  useEffect(() => {
    if (modo === "novo") {
      setForm({
        idParametro: null,
        chave: "",
        descricao: "",
        unidade: "",
        valor: "",
        ativo: "1",
      });
    }

    if (modo === "alterar" && itemSelecionado) {
      setForm({
        idParametro: itemSelecionado.IDPARAMETRO,
        chave: itemSelecionado.CHAVE || "",
        descricao: itemSelecionado.DESCRICAO || "",
        unidade: itemSelecionado.UNIDADE || "",
        valor: itemSelecionado.VALOR ?? "",
        ativo: String(itemSelecionado.ATIVO ?? "1"),
      });
    }
  }, [modo, itemSelecionado]);

  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  }

  function validarCampos() {
    const e = {};

    if (!form.chave) e.chave = "Informe a chave";
    if (!form.descricao) e.descricao = "Informe a descrição";
    if (!form.unidade) e.unidade = "Informe a unidade";
    if (form.valor === "") e.valor = "Informe o valor";

    return e;
  }

  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);
    if (Object.keys(validation).length) return;

    setLoading(true);

    try {
      if (modo === "novo") {
        const payload_create = {
          CHAVE: form.chave,
          DESCRICAO: form.descricao,
          UNIDADE: form.unidade,
          VALOR: form.valor,
          ATIVO: form.ativo,
        };

        await ConfiguracoesService.create(payload_create);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Parâmetro criado com sucesso!",
        });

        setSubmitState("SUCCESS");
      }

      if (modo === "alterar") {
        const payload_update = {
          IDPARAMETRO: form.idParametro,
          CHAVE: form.chave,
          DESCRICAO: form.descricao,
          UNIDADE: form.unidade,
          VALOR: form.valor,
          ATIVO: form.ativo,
        };

        await ConfiguracoesService.update(
          form.idParametro,
          payload_update
        );

        setRetorno({
          tipo: "sucesso",
          mensagem: "Parâmetro atualizado com sucesso!",
        });

        setSubmitState("SUCCESS");
      }

      onClose();
    } catch (error) {
      setRetorno({
        tipo: "erro",
        mensagem:
          modo === "novo"
            ? "Erro ao criar o parâmetro."
            : "Erro ao atualizar o parâmetro.",
      });

      setSubmitState("ERROR");
      onClose();
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={configIcon} alt="configurações" className="icon" />
          {modo === "novo"
            ? "Cadastro de Parâmetro"
            : "Alterar Parâmetro"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Chave: *</div>
          <input
            name="chave"
            value={form.chave}
            onChange={handleChange}
          />
          {errors.chave && (
            <span style={{ color: "red" }}>{errors.chave}</span>
          )}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Descrição: *</div>
          <input
            name="descricao"
            value={form.descricao}
            onChange={handleChange}
          />
          {errors.descricao && (
            <span style={{ color: "red" }}>{errors.descricao}</span>
          )}
        </div>

        <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Unidade: *</div>
            <select
                name="unidade"
                value={form.unidade}
                onChange={handleChange}
            >
                <option value="">Selecione</option>
                <option value="ANO">ANO</option>
                <option value="MES">MÊS</option>
                <option value="SEMANA">SEMANA</option>
                <option value="DIA">DIA</option>
                <option value="HORA">HORA</option>
                <option value="MINUTO">MINUTO</option>
            </select>
            {errors.unidade && (
                <span style={{ color: "red" }}>{errors.unidade}</span>
            )}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Valor: *</div>
          <input
            type="number"
            name="valor"
            value={form.valor}
            onChange={handleChange}
          />
          {errors.valor && (
            <span style={{ color: "red" }}>{errors.valor}</span>
          )}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Ativo:</div>
          <select
            name="ativo"
            value={form.ativo}
            onChange={handleChange}
          >
            <option value="1">Sim</option>
            <option value="0">Não</option>
          </select>
        </div>

        <div className="Form-Interno-alinhamento-button">
          <button
            type="submit"
            disabled={loading}
            className="Form-Interno-button"
          >
            {loading ? "Enviando..." : "Salvar"}
          </button>

          <button
            type="button"
            className="Form-Interno-button"
            onClick={onClose}
          >
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}